package uk.co.nickthecoder.glok.text

data class BitmapGlyphData(

    /**
     * The x coordinate of the reference point for this glyph within the texture (measured in pixels).
     */
    val x: Float,

    /**
     * The y coordinate of the reference point for this glyph within the texture (measured in pixels).
     */
    val y: Float,

    /**
     * Haw far this glyph extends relative to its reference point ([x],[y]).
     * All four bounds are >= 0.
     */
    val boundsTop: Float,
    val boundsRight: Float,
    val boundsBottom: Float,
    val boundsLeft: Float,

    /**
     * How many pixels to advance to the right before drawing the next glyph.
     *
     * This does not take into account kerning. Kerning is not supported by the fonts in Glok.
     */
    val advance: Float

) {

    val left: Float get() = x - boundsLeft
    val right: Float get() = x + boundsRight
    val top: Float get() = y - boundsTop
    val bottom: Float get() = y + boundsBottom

    /**
     * The width of this glyph (i.e. the width of the bounding rectangle which encompasses the glyph).
     * Note, the height is the same for all glyphs, and is stored on [BitmapFont].
     */
    val width: Float get() = boundsLeft + boundsRight

    val height: Float get() = boundsTop + boundsBottom

}
